import React from 'react';
import { isMobile } from 'react-device-detect';

export const wildCardSVG = (
  <svg
    className="w-full text-blue-600"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 1120.59226 777.91584"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>not found</title>
    <circle
      cx="212.59226"
      cy="103"
      r="64"
      fill="#ff6584"
    ></circle>
    <path
      d="M563.68016,404.16381c0,151.01141-89.77389,203.73895-200.51559,203.73895S162.649,555.17522,162.649,404.16381,363.16457,61.04208,363.16457,61.04208,563.68016,253.1524,563.68016,404.16381Z"
      transform="translate(-39.70387 -61.04208)"
      fill="#cbd5e1"
    ></path>
    <polygon
      points="316.156 523.761 318.21 397.378 403.674 241.024 318.532 377.552 319.455 320.725 378.357 207.605 319.699 305.687 319.699 305.687 321.359 203.481 384.433 113.423 321.621 187.409 322.658 0 316.138 248.096 316.674 237.861 252.547 139.704 315.646 257.508 309.671 371.654 309.493 368.625 235.565 265.329 309.269 379.328 308.522 393.603 308.388 393.818 308.449 394.99 293.29 684.589 313.544 684.589 315.974 535.005 389.496 421.285 316.156 523.761"
      fill="#3f3d56"
    ></polygon>
    <path
      d="M1160.29613,466.01367c0,123.61-73.4842,166.77-164.13156,166.77s-164.13156-43.16-164.13156-166.77S996.16457,185.15218,996.16457,185.15218,1160.29613,342.40364,1160.29613,466.01367Z"
      transform="translate(-39.70387 -61.04208)"
      fill="#cbd5e1"
    ></path>
    <polygon
      points="950.482 552.833 952.162 449.383 1022.119 321.4 952.426 433.154 953.182 386.639 1001.396 294.044 953.382 374.329 953.382 374.329 954.741 290.669 1006.369 216.952 954.954 277.514 955.804 124.11 950.467 327.188 950.906 318.811 898.414 238.464 950.064 334.893 945.173 428.327 945.027 425.847 884.514 341.294 944.844 434.608 944.232 446.293 944.123 446.469 944.173 447.428 931.764 684.478 948.343 684.478 950.332 562.037 1010.514 468.952 950.482 552.833"
      fill="#3f3d56"
    ></polygon>
    <ellipse
      cx="554.59226"
      cy="680.47903"
      rx="554.59226"
      ry="28.03433"
      fill="#3f3d56"
    ></ellipse>
    <ellipse
      cx="892.44491"
      cy="726.79663"
      rx="94.98858"
      ry="4.80162"
      fill="#3f3d56"
    ></ellipse>
    <ellipse
      cx="548.71959"
      cy="773.11422"
      rx="94.98858"
      ry="4.80162"
      fill="#3f3d56"
    ></ellipse>
    <ellipse
      cx="287.94432"
      cy="734.27887"
      rx="217.01436"
      ry="10.96996"
      fill="#3f3d56"
    ></ellipse>
    <circle
      cx="97.08375"
      cy="566.26982"
      r="79"
      fill="#2f2e41"
    ></circle>
    <rect
      x="99.80546"
      y="689.02332"
      width="24"
      height="43"
      transform="translate(-31.32451 -62.31008) rotate(0.67509)"
      fill="#2f2e41"
    ></rect>
    <rect
      x="147.80213"
      y="689.58887"
      width="24"
      height="43"
      transform="translate(-31.31452 -62.87555) rotate(0.67509)"
      fill="#2f2e41"
    ></rect>
    <ellipse
      cx="119.54569"
      cy="732.61606"
      rx="7.5"
      ry="20"
      transform="translate(-654.1319 782.47948) rotate(-89.32491)"
      fill="#2f2e41"
    ></ellipse>
    <ellipse
      cx="167.55414"
      cy="732.18168"
      rx="7.5"
      ry="20"
      transform="translate(-606.25475 830.05533) rotate(-89.32491)"
      fill="#2f2e41"
    ></ellipse>
    <circle
      cx="99.31925"
      cy="546.29477"
      r="27"
      fill="#fff"
    ></circle>
    <circle
      cx="99.31925"
      cy="546.29477"
      r="9"
      fill="#3f3d56"
    ></circle>
    <path
      d="M61.02588,552.94636c-6.04185-28.64075,14.68758-57.26483,46.30049-63.93367s62.13813,11.14292,68.18,39.78367-14.97834,38.93-46.59124,45.59886S67.06774,581.58712,61.02588,552.94636Z"
      transform="translate(-39.70387 -61.04208)"
      fill="currentColor"
    ></path>
    <path
      d="M257.29613,671.38411c0,55.07585-32.73985,74.3063-73.13,74.3063q-1.40351,0-2.80255-.0312c-1.87139-.04011-3.72494-.1292-5.55619-.254-36.45135-2.57979-64.77127-22.79937-64.77127-74.02113,0-53.00843,67.73872-119.89612,72.827-124.84633l.00892-.00889c.19608-.19159.29409-.28516.29409-.28516S257.29613,616.30827,257.29613,671.38411Z"
      transform="translate(-39.70387 -61.04208)"
      fill="currentColor"
    ></path>
    <path
      d="M181.50168,737.26482l26.747-37.37367-26.81386,41.4773-.07125,4.29076c-1.87139-.04011-3.72494-.1292-5.55619-.254l2.88282-55.10258-.0223-.42775.049-.0802.27179-5.20415-26.88076-41.5798,26.96539,37.67668.06244,1.105,2.17874-41.63324-23.0132-42.96551,23.29391,35.6583,2.26789-86.31419.00892-.294v.28516l-.37871,68.064,22.91079-26.98321-23.00435,32.84678-.60595,37.27566L204.18523,621.958l-21.4805,41.259-.33863,20.723,31.05561-49.79149-31.17146,57.023Z"
      transform="translate(-39.70387 -61.04208)"
      fill="#3f3d56"
    ></path>
    <circle
      cx="712.48505"
      cy="565.41532"
      r="79"
      fill="#2f2e41"
    ></circle>
    <rect
      x="741.77716"
      y="691.82355"
      width="24"
      height="43"
      transform="translate(-215.99457 191.86399) rotate(-17.08345)"
      fill="#2f2e41"
    ></rect>
    <rect
      x="787.6593"
      y="677.72286"
      width="24"
      height="43"
      transform="matrix(0.95588, -0.29376, 0.29376, 0.95588, -209.82788, 204.72037)"
      fill="#2f2e41"
    ></rect>
    <ellipse
      cx="767.887"
      cy="732.00275"
      rx="20"
      ry="7.5"
      transform="translate(-220.8593 196.83312) rotate(-17.08345)"
      fill="#2f2e41"
    ></ellipse>
    <ellipse
      cx="813.47537"
      cy="716.94619"
      rx="20"
      ry="7.5"
      transform="translate(-214.42477 209.56103) rotate(-17.08345)"
      fill="#2f2e41"
    ></ellipse>
    <circle
      cx="708.52153"
      cy="545.71023"
      r="27"
      fill="#fff"
    ></circle>
    <circle
      cx="708.52153"
      cy="545.71023"
      r="9"
      fill="#3f3d56"
    ></circle>
    <path
      d="M657.35526,578.74316c-14.48957-25.43323-3.47841-59.016,24.59412-75.0092s62.57592-8.34055,77.06549,17.09268-2.39072,41.6435-30.46325,57.63671S671.84483,604.17639,657.35526,578.74316Z"
      transform="translate(-39.70387 -61.04208)"
      fill="currentColor"
    ></path>
    <path
      d="M611.29613,661.29875c0,50.55711-30.05368,68.20979-67.13,68.20979q-1.28835,0-2.57261-.02864c-1.71785-.03682-3.41933-.1186-5.10033-.23313-33.46068-2.36813-59.45707-20.92878-59.45707-67.948,0-48.65932,62.18106-110.05916,66.85186-114.60322l.00819-.00817c.18-.17587.27-.26177.27-.26177S611.29613,610.74164,611.29613,661.29875Z"
      transform="translate(-39.70387 -61.04208)"
      fill="currentColor"
    ></path>
    <path
      d="M541.72029,721.77424l24.55253-34.30732-24.6139,38.07426-.0654,3.93872c-1.71785-.03682-3.41933-.1186-5.10033-.23313l2.6463-50.58165-.02047-.39266.045-.07361.24949-4.77718-24.67531-38.16836,24.753,34.58547.05731,1.01433,2-38.21741-21.12507-39.44039L541.80616,625.928l2.08182-79.23247.00819-.26994v.26177l-.34764,62.47962,21.031-24.76934-21.11693,30.15184-.55624,34.21735,19.63634-32.839-19.71812,37.87389-.31085,19.0228,28.50763-45.70631-28.614,52.34448Z"
      transform="translate(-39.70387 -61.04208)"
      fill="#3f3d56"
    ></path>
    <path
      d="M875.29613,682.38411c0,55.07585-32.73985,74.3063-73.13,74.3063q-1.4035,0-2.80255-.0312c-1.87139-.04011-3.72494-.1292-5.55619-.254-36.45135-2.57979-64.77127-22.79937-64.77127-74.02113,0-53.00843,67.73872-119.89612,72.827-124.84633l.00892-.00889c.19608-.19159.29409-.28516.29409-.28516S875.29613,627.30827,875.29613,682.38411Z"
      transform="translate(-39.70387 -61.04208)"
      fill="currentColor"
    ></path>
    <path
      d="M799.50168,748.26482l26.747-37.37367-26.81386,41.4773-.07125,4.29076c-1.87139-.04011-3.72494-.1292-5.55619-.254l2.88282-55.10258-.0223-.42775.049-.0802.27179-5.20415L770.108,654.01076l26.96539,37.67668.06244,1.105,2.17874-41.63324-23.0132-42.96551,23.29391,35.6583,2.26789-86.31419.00892-.294v.28516l-.37871,68.064,22.91079-26.98321-23.00435,32.84678-.606,37.27566L822.18523,632.958l-21.4805,41.259-.33863,20.723,31.05561-49.79149-31.17146,57.023Z"
      transform="translate(-39.70387 -61.04208)"
      fill="#3f3d56"
    ></path>
    <ellipse
      cx="721.51694"
      cy="656.82212"
      rx="12.40027"
      ry="39.5"
      transform="translate(-220.83517 966.22323) rotate(-64.62574)"
      fill="#2f2e41"
    ></ellipse>
    <ellipse
      cx="112.51694"
      cy="651.82212"
      rx="12.40027"
      ry="39.5"
      transform="translate(-574.07936 452.71367) rotate(-68.15829)"
      fill="#2f2e41"
    ></ellipse>
  </svg>
);

export const alertSVG = {
  danger: {
    svg: (
      <svg
        className="w-5 h-5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="red"
        viewBox="0 0 20 20"
      >
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />
      </svg>
    ),
    color: 'red',
  },
  success: {
    svg: (
      <svg
        className="w-5 h-5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="green"
        viewBox="0 0 20 20"
      >
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
      </svg>
    ),
    color: 'green',
  },
  warning: {
    svg: (
      <svg
        className="w-5 h-5"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="orange"
        viewBox="0 0 20 20"
      >
        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z" />
      </svg>
    ),
    color: 'orange',
  },
};

export const alertCloseButtonSVG = (
  <svg
    className="w-3 h-3"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      stroke="currentColor"
      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
    />
  </svg>
);

export const loadingSVG = (
  <svg
    aria-hidden="true"
    className="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
);

export const leftArrowSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const flagTR = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 -30000 90000 60000"
  >
    <path
      fill="#e30a17"
      d="m0-30000h90000v60000H0z"
    />
    <path
      fill="#fff"
      d="m41750 0 13568-4408-8386 11541V-7133l8386 11541zm925 8021a15000 15000 0 1 1 0-16042 12000 12000 0 1 0 0 16042z"
    />
  </svg>
);

export const flagEN = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 30"
    width="24"
    height="24"
  >
    <clipPath id="s">
      <path d="M0,0 v30 h60 v-30 z" />
    </clipPath>
    <clipPath id="t">
      <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
    </clipPath>
    <g clipPath="url(#s)">
      <path
        d="M0,0 v30 h60 v-30 z"
        fill="#012169"
      />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        stroke="#fff"
        strokeWidth="6"
      />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        clipPath="url(#t)"
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path
        d="M30,0 v30 M0,15 h60"
        stroke="#fff"
        strokeWidth="10"
      />
      <path
        d="M30,0 v30 M0,15 h60"
        stroke="#C8102E"
        strokeWidth="6"
      />
    </g>
  </svg>
);

export const appLogo = (
  <svg
    className={`${isMobile ? 'w-6 h-6' : 'w-10 h-10'}`}
    viewBox="51.4062 172.5492 47.4428 45"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="g-1"
      transform="matrix(0.4082449972629547, 0, 0, 0.41210299730300903, 76.89151763916016, 50.00954818725586)"
      data-uid="o_fald6ag1i_8"
    >
      <path
        id="path-2"
        d="M 0.022 392.444 C -0.979 392.444 -1.877 391.792 -2.199 390.818 L -11.18 363.416 L -38.119 354.281 C -38.993 353.987 -39.61 353.197 -39.704 352.27 C -39.802 351.338 -39.348 350.44 -38.553 349.974 L 50.275 297.67 C 51.075 297.209 52.052 297.252 52.786 297.78 C 53.534 298.307 53.908 299.23 53.749 300.143 L 39.723 380.975 C 39.602 381.688 39.162 382.306 38.531 382.654 C 37.909 383.001 37.161 383.034 36.497 382.749 L 6.417 369.64 L 2.308 390.542 C 2.102 391.597 1.223 392.382 0.162 392.449 C 0.12 392.439 0.068 392.444 0.022 392.444 Z M -31.718 351.438 L -8.59 359.279 C -7.894 359.512 -7.342 360.073 -7.113 360.781 L -0.549 380.818 L 2.401 365.821 C 2.537 365.123 2.981 364.519 3.607 364.186 C 4.229 363.848 4.968 363.82 5.618 364.105 L 35.632 377.186 L 48.274 304.337 L -31.718 351.438 Z"
        fill="#fff"
        data-uid="o_fald6ag1i_9"
      />
      <path
        id="path-3"
        d="M 4.698 369.508 C 4.226 369.508 3.754 369.366 3.338 369.066 C 2.286 368.305 2.047 366.817 2.795 365.752 L 33.133 322.559 L -7.677 364.059 C -8.589 364.986 -10.071 364.986 -10.982 364.059 C -11.894 363.132 -11.894 361.625 -10.982 360.697 L 49.795 298.885 C 50.66 298.005 52.03 297.948 52.96 298.751 C 53.886 299.55 54.054 300.939 53.353 301.947 L 6.601 368.514 C 6.148 369.161 5.423 369.508 4.698 369.508 Z"
        fill="#fff"
        data-uid="o_fald6ag1i_10"
      />
      <path
        id="path-4"
        d="M 0.809 394.079 C 0.322 394.079 -0.173 393.922 -0.594 393.604 C -1.627 392.814 -1.837 391.326 -1.066 390.275 L 12.959 371.256 C 13.74 370.2 15.204 369.996 16.232 370.781 C 17.265 371.57 17.476 373.058 16.704 374.109 L 2.679 393.128 C 2.221 393.751 1.515 394.079 0.809 394.079 Z"
        fill="#fff"
        data-uid="o_fald6ag1i_11"
      />
      <path
        id="path-5"
        d="M -1.767 374.605 C -1.862 374.605 -1.957 374.571 -2.033 374.5 C -2.228 374.317 -2.421 374.129 -2.611 373.935 C -2.764 373.78 -2.764 373.527 -2.611 373.371 C -2.458 373.215 -2.209 373.215 -2.056 373.37 C -1.874 373.555 -1.688 373.737 -1.501 373.912 C -1.342 374.061 -1.331 374.314 -1.478 374.477 C -1.556 374.561 -1.662 374.605 -1.767 374.605 Z"
        fill="#fff"
        data-uid="o_fald6ag1i_12"
      />
      <path
        id="path-6"
        d="M -36.961 406.548 C -39.167 406.548 -41.43 406.311 -43.683 405.84 C -44.95 405.578 -45.759 404.323 -45.507 403.034 C -45.245 401.746 -43.997 400.933 -42.744 401.18 C -40.799 401.584 -38.854 401.789 -36.961 401.789 C -36.951 401.789 -36.942 401.789 -36.932 401.789 L -35.881 401.77 C -34.361 401.684 -33.501 402.749 -33.454 404.057 C -33.407 405.364 -34.422 406.477 -35.708 406.525 L -36.928 406.548 C -36.937 406.548 -36.951 406.548 -36.961 406.548 Z M -53.712 401.998 C -54.076 401.998 -54.441 401.912 -54.787 401.732 C -56.966 400.581 -59.196 399.197 -61.421 397.628 C -62.487 396.877 -62.744 395.393 -62.006 394.319 C -61.267 393.235 -59.803 392.978 -58.756 393.725 C -56.699 395.184 -54.637 396.459 -52.632 397.514 C -51.486 398.118 -51.038 399.554 -51.636 400.719 C -52.052 401.532 -52.866 401.998 -53.712 401.998 Z"
        fill="#fff"
        data-uid="o_fald6ag1i_13"
      />
      <path
        id="path-7"
        d="M -20.35 402.587 C -21.257 402.587 -22.122 402.045 -22.501 401.146 C -23.006 399.938 -22.454 398.54 -21.267 398.022 C -19.972 397.456 -18.658 396.791 -17.354 396.006 C -16.246 395.34 -14.815 395.711 -14.151 396.848 C -13.492 397.979 -13.861 399.434 -14.979 400.105 C -16.423 400.97 -17.919 401.745 -19.429 402.401 C -19.729 402.53 -20.042 402.587 -20.35 402.587 Z"
        fill="#fff"
        data-uid="o_fald6ag1i_14"
      />
    </g>
  </svg>
);
